module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/area-creation-grid/area-creation-grid.component.css
// module id = ./src/app/masters/area-creation-grid/area-creation-grid.component.css
// module chunks = main